import { cn } from '@repo/ui';
import type { ReactElement, ReactNode } from 'react';

interface SitePageShellProps {
  readonly header: ReactNode;
  /** 본문 아래 전폭으로 깔리는 푸터. */
  readonly footer: ReactNode;
  readonly children: ReactNode;
  /** 본문 컨테이너에 더할 클래스. */
  readonly className?: string;
}

/**
 * 고객 웹 화면 틀 — 본문을 헤더 흰 줄·HOME 과 같은 전폭 여백(px-5 · sm:px-8 · xl:px-14)에 맞춘다.
 * 가운데 폭 제한을 두지 않아 넓은 화면에서도 헤더 로고·메뉴와 본문 좌우 끝이 같은 선에 선다.
 * 한국어는 어절 단위로 줄을 바꾼다 — 단어 중간에서 끊기지 않게.
 */
export const SitePageShell = ({
  header,
  footer,
  children,
  className,
}: SitePageShellProps): ReactElement => (
  <div className="flex min-h-dvh flex-col bg-background break-keep">
    {header}

    <main
      className={cn('w-full flex-1 px-5 pt-10 pb-24 sm:px-8 sm:pt-12 sm:pb-32 xl:px-14', className)}
    >
      {children}
    </main>

    {footer}
  </div>
);
